/* eslint-disable func-names */
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// routes
// import {toast} from "react-toastify"
import { useEffect } from 'react';

import ReactGA from 'react-ga4';
import { useLocation } from 'react-router';
import Router from './routes';
// theme
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { ChartStyle } from './components/chart';
import NotistackProvider from './components/NotistackProvider';
import ScrollToTop from './components/ScrollToTop';
import ThemeSettings from './components/settings';
import ThemeProvider from './theme';

ReactGA.initialize('G-YP4HWS7S53');

// ----------------------------------------------------------------------
export default function App() {
  const { pathname, search } = useLocation();
  // const CLIENT_ID = '633537869211-vrbn6fg19surcab49lph9ua9b6fcppdm.apps.googleusercontent.com';
  // const PROPERTY_ID = 344077181;

  useEffect(() => {
    const path = pathname + search;
    ReactGA.send({ hitType: 'pageview', page: path });
  }, [pathname, search]);

  return (
    <>
      <MotionLazyContainer>
        <ThemeProvider>
          <ThemeSettings>
            <NotistackProvider>
              {/* <ProgressBarStyle /> */}
              <ChartStyle />
              <ScrollToTop />
              <Router />
            </NotistackProvider>
          </ThemeSettings>
        </ThemeProvider>
      </MotionLazyContainer>
      <ToastContainer />
    </>
  );
}
